import { api } from "./api";

const KEY = "instabridge_attorney";

export const saveAttorney = (data) => localStorage.setItem(KEY, JSON.stringify(data));
export const getAttorney = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};
export const clearAttorney = () => localStorage.removeItem(KEY);

export const fetchAttorneyMe = async () => {
  const { data } = await api.get("/attorney/auth/me");
  const prev = getAttorney() || {};
  saveAttorney({ ...data, session_token: prev.session_token, expires_at: prev.expires_at });
  return data;
};

export const attorneyLogout = async () => {
  try { await api.post("/attorney/auth/logout"); } catch { /* ignore */ }
  clearAttorney();
};

// Build the Emergent OAuth login URL. NEVER hardcode the redirect; always derive from window.location.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const buildEmergentLoginUrl = () => {
  const redirectUrl = window.location.origin + "/attorney/portal";
  return `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

// Redeem a long-lived magic-link portal token for an attorney session.
// Persists session_token to localStorage so the axios interceptor picks it up.
export const redeemMagicLink = async (token) => {
  const { data } = await api.post(`/portal/redeem/${encodeURIComponent(token)}`);
  // Pull the firm profile so the saved blob matches fetchAttorneyMe shape
  const meReq = await api.get("/portal/me", { headers: { Authorization: `Bearer ${data.session_token}` } });
  const me = meReq.data;
  saveAttorney({
    user: { ...me.user, role: "attorney" },
    session_token: data.session_token,
    expires_at: data.expires_at,
    firm: me.firm,
  });
  return me;
};
